exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Pager {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n}\r\n\r\n.Pager > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\t    flex-direction: column;\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/Pager/Pager.css
// module id = 696
// module chunks = 0